import React from "react";
import { Navigate, Outlet  } from "react-router-dom";
import { isMobile } from "../Common";

const MobileUsersNotAllowed = () => {
    return !isMobile() ? <Outlet /> : <Navigate to="/mobile" />
}

export default MobileUsersNotAllowed;